const isUrl = (value: string) => {
  let url: URL;

  try {
    url = new URL(value);
  } catch {
    return false;
  }

  return /https?:/.test(url.protocol);
};

export default isUrl;
